/**
 * Variant Sale Badge Handler
 * Simply shows/hides sale badges when variants change
 */
(function() {
  'use strict';

  // Prevent multiple initializations
  if (window.variantSaleBadgeInitialized) {
    return;
  }
  window.variantSaleBadgeInitialized = true;

  function initVariantSaleBadge() {
    // Find all product sections
    const productSections = document.querySelectorAll('[data-section-type="product"]');
    
    productSections.forEach(function(section) {
      // Listen for variant change events
      section.addEventListener('variantChange', function(event) {
        updateSaleBadge(event.detail.variant, section);
      });
    });
  }

  function updateSaleBadge(variant, section) {
    if (!variant) return;

    // Check if variant is on sale
    const isOnSale = variant.compare_at_price > variant.price;
    
    // Find all product media slides in this section
    const mediaSlides = section.querySelectorAll('.product-main-slide');
    
    mediaSlides.forEach(function(slide) {
      // Find existing sale badge in this slide
      let saleBadge = slide.querySelector('.grid-product__tag--sale');
      
      if (isOnSale) {
        // Show sale badge
        if (saleBadge) {
          saleBadge.style.display = 'block';
        } else {
          // Create sale badge if it doesn't exist
          saleBadge = document.createElement('div');
          saleBadge.className = 'grid-product__tag grid-product__tag--sale';
          saleBadge.textContent = 'Sale';
          saleBadge.style.display = 'block';
          
          // Insert at the beginning of the slide
          slide.insertBefore(saleBadge, slide.firstChild);
        }
      } else {
        // Hide sale badge
        if (saleBadge) {
          saleBadge.style.display = 'none';
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSaleBadge);
  } else {
    initVariantSaleBadge();
  }
})(); 